(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lrc-header"] && !Shopify.designMode) return;
  try {
    
  class LrcMobileMenu extends HTMLElement {
    connectedCallback() {
      this.openButton = this.querySelector('[data-lrc-menu-open]');
      this.closeButton = this.querySelector('[data-lrc-menu-close]');
      this.dialog = this.querySelector('[data-lrc-menu-dialog]');
      this.desktopMedia = window.matchMedia('(min-width: 990px)');

      if (!this.openButton || !this.closeButton || !this.dialog) return;

      this.handleOpen = () => this.openMenu();
      this.handleClose = () => this.closeMenu();
      this.handleCancel = (event) => {
        event.preventDefault();
        this.closeMenu();
      };
      this.handleKeydown = (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        this.closeMenu();
      };
      this.handleDialogClick = (event) => {
        if (event.target === this.dialog) this.closeMenu();
        if (event.target instanceof Element && event.target.closest('a')) this.closeMenu(false);
      };
      this.handleBreakpoint = (event) => {
        if (event.matches) this.closeMenu(false);
      };
      this.handleClosed = () => {
        this.dialog.classList.remove('is-closing');
        this.openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('lrc-mobile-menu-open');
      };

      this.openButton.addEventListener('click', this.handleOpen);
      this.closeButton.addEventListener('click', this.handleClose);
      this.dialog.addEventListener('cancel', this.handleCancel);
      this.dialog.addEventListener('keydown', this.handleKeydown);
      this.dialog.addEventListener('click', this.handleDialogClick);
      this.dialog.addEventListener('close', this.handleClosed);
      this.desktopMedia.addEventListener('change', this.handleBreakpoint);
    }

    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.handleOpen);
      this.closeButton?.removeEventListener('click', this.handleClose);
      this.dialog?.removeEventListener('cancel', this.handleCancel);
      this.dialog?.removeEventListener('keydown', this.handleKeydown);
      this.dialog?.removeEventListener('click', this.handleDialogClick);
      this.dialog?.removeEventListener('close', this.handleClosed);
      this.desktopMedia?.removeEventListener('change', this.handleBreakpoint);
      document.documentElement.classList.remove('lrc-mobile-menu-open');
    }

    openMenu() {
      if (this.dialog.open) return;
      this.openButton.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lrc-mobile-menu-open');

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    closeMenu(returnFocus = true) {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      this.dialog.classList.add('is-closing');

      window.setTimeout(() => {
        this.dialog.close();
        if (returnFocus) this.openButton.focus();
      }, 320);
    }
  }

  if (!customElements.get('lrc-mobile-menu')) {
    customElements.define('lrc-mobile-menu', LrcMobileMenu);
  }

  class LrcHeaderAccount extends HTMLElement {
    connectedCallback() {
      this.loginButtons = [...this.querySelectorAll('[data-lrc-header-login]')];
      this.cartCounts = [...this.querySelectorAll('[data-lrc-cart-count]')];
      this.statusNode = this.querySelector('[data-lrc-header-auth-status]');
      this.handleLogin = () => this.openLogin();
      this.handleCartRefresh = () => this.syncCart();
      // Horizon product forms publish the resolved cart through this standard
      // event after an add/update completes. Keep the custom LRC badge in
      // sync with that shared storefront state as well as legacy LRC events.
      this.handleStandardCartRefresh = (event) => {
        event.promise?.then(() => this.syncCart()).catch(() => {
          // The native cart components own user-facing error handling.
        });
      };
      this.loginButtons.forEach((button) => button.addEventListener('click', this.handleLogin));
      window.addEventListener('cart:refresh', this.handleCartRefresh);
      document.addEventListener('cart:update', this.handleCartRefresh);
      document.addEventListener('shopify:cart:lines-update', this.handleStandardCartRefresh);
      this.startWhenReady();
    }

    disconnectedCallback() {
      this.loginButtons?.forEach((button) => button.removeEventListener('click', this.handleLogin));
      window.removeEventListener('cart:refresh', this.handleCartRefresh);
      document.removeEventListener('cart:update', this.handleCartRefresh);
      document.removeEventListener('shopify:cart:lines-update', this.handleStandardCartRefresh);
      window.clearInterval(this.authStateTimer);
      window.clearTimeout(this.statusTimer);
    }

    async startWhenReady() {
      if (document.readyState === 'loading') {
        await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
      }

      try {
        const quick = await this.waitForQuick();
        const mountNode = document.getElementById(this.dataset.mountTarget);
        if (!mountNode?.dataset.lrcQuickMounted) {
          await quick.mount({
            enabled: true,
            customerAccountEnabled: true,
            targetId: this.dataset.mountTarget,
            apiBaseUrl: this.dataset.apiBaseUrl,
            shopDomain: this.dataset.shopDomain,
            bootstrapPath: '/api/v1/customer-auth/bootstrap',
            showAccountTrigger: false,
            mode: 'overlay',
            accountUrl: this.dataset.accountUrl,
            heading: 'My LRC Account'
          });
        }

        this.syncAuthState();
        this.authStateTimer = window.setInterval(() => this.syncAuthState(), 750);
      } catch {
        this.setStatus('Login is temporarily unavailable. Please try again.');
      }
    }

    waitForQuick(timeout = 8000) {
      if (window.LRCQuick) return Promise.resolve(window.LRCQuick);

      return new Promise((resolve, reject) => {
        const startedAt = Date.now();
        const timer = window.setInterval(() => {
          if (window.LRCQuick) {
            window.clearInterval(timer);
            resolve(window.LRCQuick);
          } else if (Date.now() - startedAt >= timeout) {
            window.clearInterval(timer);
            reject(new Error('LRC account runtime unavailable'));
          }
        }, 50);
      });
    }

    syncAuthState() {
      const signedIn = window.LRCQuick?.getAuthState().status === 'SIGNED_IN';
      const changed = this.authSignedIn !== signedIn;
      this.authSignedIn = signedIn;
      this.querySelectorAll('[data-lrc-auth-visibility="signed-out"]').forEach((element) => {
        element.hidden = signedIn;
      });
      this.querySelectorAll('[data-lrc-auth-visibility="signed-in"]').forEach((element) => {
        element.hidden = !signedIn;
      });
      if (changed && signedIn) {
        console.debug('[LRC account] Signed-in state confirmed.');
      }
    }

    async syncCart() {
      try {
        const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        this.cartCounts?.forEach((node) => { node.textContent = String(cart.item_count || 0); });
      } catch {
        // Cart count remains at the last confirmed value when Shopify is unreachable.
      }
    }

    async openLogin() {
      this.loginButtons.forEach((button) => {
        button.disabled = true;
      });
      this.setStatus('Opening secure phone login…');

      const mobileMenu = this.querySelector('lrc-mobile-menu');
      if (mobileMenu?.dialog?.open) mobileMenu.closeMenu(false);

      try {
        const quick = await this.waitForQuick();
        const mountNode = document.getElementById(this.dataset.mountTarget);
        if (!mountNode?.dataset.lrcQuickMounted) {
          await quick.mount({
            enabled: true,
            customerAccountEnabled: true,
            targetId: this.dataset.mountTarget,
            apiBaseUrl: this.dataset.apiBaseUrl,
            shopDomain: this.dataset.shopDomain,
            bootstrapPath: '/api/v1/customer-auth/bootstrap',
            showAccountTrigger: false,
            mode: 'overlay',
            accountUrl: this.dataset.accountUrl,
            heading: 'My LRC Account'
          });
        }

        await new Promise((resolve) => window.setTimeout(resolve, mobileMenu?.dialog?.open ? 340 : 0));

        let lastError;
        for (let attempt = 0; attempt < 30; attempt += 1) {
          try {
            await quick.openLogin();
            this.setStatus('Secure phone login opened.');
            return;
          } catch (error) {
            lastError = error;
            await new Promise((resolve) => window.setTimeout(resolve, 100));
          }
        }
        throw lastError;
      } catch {
        this.setStatus('Login is temporarily unavailable. Please try again.');
      } finally {
        this.loginButtons.forEach((button) => {
          button.disabled = false;
        });
      }
    }

    setStatus(message) {
      if (!this.statusNode) return;
      window.clearTimeout(this.statusTimer);
      this.statusNode.textContent = message;
      if (message) {
        this.statusTimer = window.setTimeout(() => {
          this.statusNode.textContent = '';
        }, 4000);
      }
    }
  }

  if (!customElements.get('lrc-header-account')) {
    customElements.define('lrc-header-account', LrcHeaderAccount);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
